/**
 * 交易模块接口列表
 */

import base from './base'; // 导入接口域名列表
import axios from './axios';
import qs from 'qs';
import login from "./user"; // 根据需求是否导入qs模块

//获取用户列表
export const getclient = ()=>{
  return axios.post(`${base.base}/trade/get_list_client`)
};

//获取可以交易合约列表
export const getcontract = (params)=>{
  return axios.post(`${base.base}/trade/get_list_contract`,
    qs.stringify(params)
  )
};

//获取所有交易合约列表
export const getcontract_all = (params)=>{
  return axios.post(`${base.base}/trade/get_list_contract_all`,
    qs.stringify(params)
  )
};

//获取所有交易合约列表
export const getcontract_update = (params)=>{
  return axios.post(`${base.base}/trade/get_list_contract_update`,
    qs.stringify(params)
  )
};

//获取用户基本信息、风险控制
export const getclientinfo = (params)=>{
  return axios.post(`${base.base}/trade/get_client_info`,
    qs.stringify(params)
  )
};
//获取合约基础参数、批量参数
export const getParameter = (params)=>{
  return axios.post(`${base.base}/trade/get_parameter`,
    qs.stringify(params)
  )
};

//添加合约基础参数、批量参数
export const inseertParameter = (params)=>{
  return axios.post(`${base.base}/trade/insert_parameter`,
    qs.stringify(params)
  )
};
//删除合约基础参数、批量参数
export const deleteParameter = (params)=>{
  return axios.post(`${base.base}/trade/delete_parameter`,
    qs.stringify(params)
  )
};
//修改合约基础参数、批量参数
export const updateParameter = (params)=>{
  return axios.post(`${base.base}/trade/update_parameter`,
    qs.stringify(params)
  )
};
//修改风险信息
export const updateRisk = (params)=>{
  return axios.post(`${base.base}/trade/update_risk`,
    qs.stringify(params)
  )
};
//获取添加策略强平点
export const getLatestLiquidation = (params)=>{
  return axios.post(`${base.base}/trade/get_latest_liquidation`,
    qs.stringify(params)
  )
};
//添加启动策略
export const insertStrategy = (params)=>{
  return axios.post(`${base.base}/trade/insert_strategy`,
    qs.stringify(params)
  )
};
//启动所选未启动策略
export const startStrategy = (params)=>{
  return axios.post(`${base.base}/trade/start_strategy`,
    qs.stringify(params)
  )
};
//删除所选未启动策略
export const deleteStrategy = (params)=>{
  return axios.post(`${base.base}/trade/delete_strategy`,
    qs.stringify(params)
  )
};
//获取最新价格、获取指数价格
export const getPrice = ()=>{
  return axios.post(`${base.base}/trade/get_list_price_pro`,
  )
};
//一键平移
export const translationAll = (params)=>{
  return axios.post(`${base.base}/trade/translation`,
    qs.stringify(params)
  )
};
//策略停止
export const stopAll = (params)=>{
  return axios.post(`${base.base}/trade/stop`,
    qs.stringify(params)
  )
};
//平仓
export const endAll = (params)=>{
  return axios.post(`${base.base}/trade/end`,
    qs.stringify(params)
  )
};
//同步委托
export const synchronous = (params)=>{
  return axios.post(`${base.base}/trade/synchronous`,
    qs.stringify(params)
  )
};
//修改策略参数
export const updateStrategy = (params)=>{
  return axios.post(`${base.base}/trade/update_strategy`,
    qs.stringify(params)
  )
};
//选中编辑
export const updateStrategyBatch = (params)=>{
  return axios.post(`${base.base}/trade/update_strategy_batch`,
    qs.stringify(params)
  )
};
//委托分布图
export const distributionEntrust = (params)=>{
  return axios.post(`${base.base}/trade/distribution_entrust`,
    qs.stringify(params)
  )
};
//委托分布图——2
export const distributionEntrust2 = (params)=>{
  return axios.post(`${base.base}/trade/distribution_entrust_2`,
    qs.stringify(params)
  )
};
//委托分布图——3
export const distributionEntrust3 = (params)=>{
  return axios.post(`${base.base}/trade/distribution_entrust_3`,
    qs.stringify(params)
  )
};

//盈亏计算切换是否包含未启动
export const updateProfitLossCal = (params)=>{
  return axios.post(`${base.base}/trade/update_profit_loss_cal`,
    qs.stringify(params)
  )
};
//获取自动平移参数
export const updateautotranslation = (params)=>{
  return axios.post(`${base.base}/trade/get_autotranslation3`,
    qs.stringify(params)
  )
};
//删除平移中选中的
export const deletePointTranslation_multi =(params)=>{
  return axios.post(`${base.base}/trade/delete_autotranslation3_multi`,
    qs.stringify(params)
  )
}
//平移添加
export const insertautotranslation =(params)=>{
  return axios.post(`${base.base}/trade/insert_autotranslation3`,
    qs.stringify(params)
  )
}
//平移修改
export const update_autotranslation3 =(params)=>{
  return axios.post(`${base.base}/trade/update_autotranslation3`,
    qs.stringify(params)
  )
}
//激活平移选中
export const activate_autotranslation3_multi =(params)=>{
  return axios.post(`${base.base}/trade/activate_autotranslation3_multi`,
    qs.stringify(params)
  )
}
//获取启动数据
export const get_autostart3 =(params)=>{
 
  return axios.post(`${base.base}/trade/get_autostart3`,
    qs.stringify(params)
   
  )

}
//添加启动数据
export const insert_autostart3 =(params)=>{
  return axios.post(`${base.base}/trade/insert_autostart3`,
    qs.stringify(params)
  )
}
//删除启动数据
export const delete_autostart3_multi =(params)=>{
  return axios.post(`${base.base}/trade/delete_autostart3_multi`,
    qs.stringify(params)
  )

}
//激活启动选中
export const activate_autostart3_multi =(params)=>{
  return axios.post(`${base.base}/trade/activate_autostart3_multi`,
    qs.stringify(params)
  )
}
//编辑启动
export const update_autostart3 =(params)=>{
  return axios.post(`${base.base}/trade/update_autostart3`,
    qs.stringify(params)
  )
}
//获取离场数据
export const get_autoleave3 =(params)=>{
  return axios.post(`${base.base}/trade/get_autoleave3`,
    qs.stringify(params)
  )
}
//添加离场数据
export const insert_autoleave3 =(params)=>{
  return axios.post(`${base.base}/trade/insert_autoleave3`,
    qs.stringify(params)
  )
}
//删除场数据
export const delete_autoleave3_multi =(params)=>{
  return axios.post(`${base.base}/trade/delete_autoleave3_multi`,
    qs.stringify(params)
  )
}
//激活场数据
export const activate_autoleave3_multi =(params)=>{
  return axios.post(`${base.base}/trade/activate_autoleave3_multi`,
    qs.stringify(params)
  )
}
//编辑场数据
export const update_autoleave3 =(params)=>{
  return axios.post(`${base.base}/trade/update_autoleave3`,
    qs.stringify(params)
  )
}
//获取冲刺数据
export const get_sprint3 =(params)=>{
  return axios.post(`${base.base}/trade/get_sprint3`,
    qs.stringify(params)
  )
}
//添加冲刺数据
export const insert_sprint3 =(params)=>{
  return axios.post(`${base.base}/trade/insert_sprint3`,
    qs.stringify(params)
  )
}
//删除冲刺数据
export const delete_sprint3_multi =(params)=>{
  return axios.post(`${base.base}/trade/delete_sprint3_multi`,
    qs.stringify(params)
  )
}
//激活冲刺数据
export const activate_sprint3_multi =(params)=>{
  return axios.post(`${base.base}/trade/activate_sprint3_multi`,
    qs.stringify(params)
  )
}
//编辑冲刺数据
export const update_sprint3 =(params)=>{
  return axios.post(`${base.base}/trade/update_sprint3`,
    qs.stringify(params)
  )
}
//编辑冲刺数据
export const insert_autoexecute3 =(params)=>{
  return axios.post(`${base.base}/trade/insert_autoexecute3`,
    qs.stringify(params)
  )
}
//获取自动执行数据
export const get_autoexecute3 =(params)=>{
  return axios.post(`${base.base}/trade/get_autoexecute3`,
    qs.stringify(params)
  )
}
export const update_autoexecute3 =(params)=>{
  return axios.post(`${base.base}/trade/update_autoexecute3`,
    qs.stringify(params)
  )
}
export const delete_autoexecute3_multi =(params)=>{
  return axios.post(`${base.base}/trade/delete_autoexecute3_multi`,
    qs.stringify(params)
  )
}
export const activate_autoexecute3_multi =(params)=>{
  return axios.post(`${base.base}/trade/activate_autoexecute3_multi`,
    qs.stringify(params)
  )
}
export const get_liquidation_pro =(params)=>{
  return axios.post(`${base.base}/trade/get_liquidation_pro`,
    qs.stringify(params)
  )
}
export default getclient;



// WEBPACK FOOTER //
// ./src/api/trade.js